import { Link, NavLink, useNavigate } from "react-router-dom";
import { AiOutlineCheck } from "react-icons/ai";
import {
  FaChartLine, FaCoins, FaEnvelope, FaFileAlt,
  FaIdBadge, FaMoneyBill, FaShieldAlt, FaStar,
  FaTelegram, FaThList, FaWallet, FaWhatsapp,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import FAQ from "./faq";

import bbc from "../assets/BBC_Logo_2021.svg";
import theblockl from "../assets/the_block-removebg-preview.png";
import currency from "../assets/currency-removebg-preview.png";
import motherboard from "../assets/images__1_-removebg-preview.png";
import forbes from "../assets/images__5_-removebg-preview.png";
import hypebeast from "../assets/Hypebeast-Logo.svg";
import rakuten from "../assets/rakuten.png";
import binance from "../assets/binance.png";
import caseware from "../assets/caseware.png";
import galaxy from "../assets/galaxy.png";
import trust from "../assets/trustwallet.png";
import block from "../assets/blcokchain.png";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

// ─── Data ────────────────────────────────────────────────────────────────────

const HERO_SOCIALS = [
  { href: "https://wa.me/8562054097092", icon: <FaWhatsapp size={15} />, label: "WhatsApp" },
  { href: "https://t.me/shieldcrypt_help", icon: <FaTelegram size={15} />, label: "Telegram" },
  { href: "mailto:support@shieldcrypt.help", icon: <FaEnvelope size={15} />, label: "Email" },
];

const PARTNERS = [
  { src: trust, href: "https://trustwallet.com" },
  { src: bbc, href: "https://www.bbc.com" },
  { src: rakuten, href: "https://www.rakuten.com" },
  { src: theblockl, href: "https://www.theblock.co" },
  { src: currency, href: "https://currency.com" },
  { src: binance, href: "https://www.binance.com" },
  { src: block, href: "https://www.blockchain.com" },
  { src: motherboard, href: "https://www.vice.com" },
  { src: galaxy, href: "https://www.galaxy.com" },
  { src: forbes, href: "https://www.forbes.com" },
  { src: caseware, href: "https://www.caseware.com" },
  { src: hypebeast, href: "https://hypebeast.com" },
];

const ABOUT_POINTS = [
  "Our objective is to foster an informed community that is equipped to identify and combat fraudulent activities while also promoting awareness and understanding of digital currencies.",
  "We offer expedited recovery of lost cryptocurrencies and passwords without upfront fees, ensuring a resolution within 72 hours.",
  "Crypto Recovery, hacking services, crypto investment, crypto mining, and more...",
  "We have successfully resolved over 500,000 issues.",
  "Our customer support team is available round the clock, every day of the year.",
];

const HOW_IT_WORKS = [
  {
    step: "01",
    icon: <FaFileAlt size={20} color="#C4622D" />,
    title: "File a complaint",
    desc: "Our easy-to-use complaint filing system allows you to quickly and easily submit your concerns to our team.",
  },
  {
    step: "02",
    icon: <AiOutlineCheck size={20} color="#C4622D" />,
    title: "Process and Review complaint",
    desc: "Our easy-to-use complaint filing system allows you to quickly and easily submit your concerns to our team.",
  },
  {
    step: "03",
    icon: <FaCoins size={20} color="#C4622D" />,
    title: "Complaint Resolved",
    desc: "Our easy-to-use complaint filing system allows you to quickly and easily submit your concerns to our team.",
  },
];

const SERVICES = [
  {
    icon: <FaWallet size={15} color="#C4622D" />,
    title: "Wallet Recovery",
    desc: "Our advanced techniques are used to recover lost or forgotten phrases, private keys, and passwords.",
  },
  {
    icon: <FaChartLine size={15} color="#C4622D" />,
    title: "Asset Recovery",
    desc: "We have the expertise to trace stolen assets and work with law enforcements to recover your funds.",
  },
  {
    icon: <FaThList size={15} color="#C4622D" />,
    title: "Asset Consultation",
    desc: "We provide valuable insights, analysis, and tailored consulting services to help you make informed decisions about your investments.",
  },
  {
    icon: <FaMoneyBill size={15} color="#C4622D" />,
    title: "Transactions Glitch",
    desc: "We provide valuable insights, analysis, and tailored consulting services to help you make informed decisions about your investments.",
  },
];

const TESTIMONIALS = [
  { name: "Jane Williams", initials: "JW", location: "London, UK", title: "Recovered lost Bitcoin from investment fraud", content: "I totally recommend ShieldCrypt hacking services. They are reliable ethical hackers. I was able to recover my lost bitcoin in an investment fraud.", verified: true },
  { name: "Liam Johnson", initials: "LJ", location: "Sydney, Australia", title: "Account recovery and security restoration", content: "I had a great experience with ShieldCrypt hacking services. Their team helped me regain access to my compromised account and secured it from further threats.", verified: true },
  { name: "Sophia Martinez", initials: "SM", location: "Toronto, Canada", title: "Stolen funds successfully recovered", content: "Thanks to ShieldCrypt, I recovered my stolen funds. They were professional and provided excellent customer support throughout the recovery process.", verified: true },
  { name: "Noah Davis", initials: "ND", location: "Paris, France", title: "Recovered important documents after breach", content: "I highly recommend ShieldCrypt for their outstanding hacking services. They helped me recover important documents lost due to a security breach.", verified: true },
  { name: "Ava Wilson", initials: "AW", location: "Tokyo, Japan", title: "Crypto assets recovered successfully", content: "ShieldCrypt is the best in the business. Their expertise in cryptocurrency recovery is unmatched. They successfully recovered my stolen coins.", verified: true },
  { name: "Devin Watson", initials: "DW", location: "Berlin, Germany", title: "Business saved after cyber attack", content: "ShieldCrypt saved my business from a devastating cyber attack. Their quick response and effective solutions secured my data in no time.", verified: true },
  { name: "Kira Sims", initials: "KS", location: "Madrid, Spain", title: "Recovered hacked social media accounts", content: "I was skeptical at first, but ShieldCrypt proved trustworthy and efficient. They helped me retrieve my hacked social media accounts.", verified: true },
  { name: "Lucas Jose", initials: "LJ", location: "Mexico City, Mexico", title: "Crypto recovery and security guidance", content: "Excellent service! ShieldCrypt recovered my lost cryptocurrency and gave me advice on preventing future attacks.", verified: true },
  { name: "Isabella Rodriguez", initials: "IR", location: "Rome, Italy", title: "Phishing attack recovery", content: "ShieldCrypt's team helped me recover funds after a phishing attack and secure my accounts.", verified: true },
  { name: "Bert Dunn", initials: "BD", location: "Seoul, South Korea", title: "Ransomware recovery success", content: "Outstanding service. They helped me retrieve encrypted files after a ransomware attack and strengthened my system security.", verified: true },
  { name: "Emma Kim", initials: "EK", location: "Vancouver, Canada", title: "Recovered digital assets successfully", content: "ShieldCrypt went above and beyond to recover my digital assets. Their dedication and professionalism were impressive.", verified: true },
  { name: "Michael Turner", initials: "MT", location: "Austin, USA", title: "Fast recovery after exchange breach", content: "After my exchange account was compromised, ShieldCrypt acted fast and helped me recover my assets.", verified: true },
  { name: "Daniel Okafor", initials: "DO", location: "Lagos, Nigeria", title: "Professional and transparent recovery process", content: "The team explained every step clearly and kept me informed throughout. I was impressed by their professionalism and dedication.", verified: true },
  { name: "Aisha Rahman", initials: "AR", location: "Kuala Lumpur, Malaysia", title: "Professional crypto recovery service", content: "ShieldCrypt's team was responsive, transparent, and effective. They helped me recover my digital assets without stress.", verified: true },
];

// ─── Component ───────────────────────────────────────────────────────────────

function Home() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  const fade = (delay = 0) =>
    `transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`;

  return (
    <div className="bg-[#F7F3EC]">

      {/* ── Hero ── */}
      <section className="px-8 pt-10 md:pt-28 pb-24 border-b border-[#E0D9CC]">
        <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2">
          <span>
            {/* <p className={`${fade(0)} text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-6`}
            style={{ transitionDelay: "0ms" }}>
            Trusted Crypto Recovery
          </p> */}

            <h1 className={`${fade()} sc-serif text-[clamp(1.6rem,4.5vw,2.4rem)] md:text-[clamp(2.2rem,3.5vw,3.8rem)] leading-[1.08] text-[#1C1A16] mb-8 max-w-[700px]`}
              style={{ transitionDelay: "80ms" }}>
              Shieldcrypt provides professional help to victims of cybercrime, digital fraud & online scams/harm
            </h1>

            <p className={`${fade()} text-[1.05rem] text-[#6B6457] leading-[1.75] max-w-[520px] mb-11`}
              style={{ transitionDelay: "160ms" }}>
              We help people like you. More than 500,000 individuals have accessed our helpline and we have solved cases without asking for any upfront payment. Reach out to us and get immediate assistance on how to deal with any of your cybersecurity issues. We provide accurate security and we work in conjuction with the Law Enforcement Agencies.          </p>

            <div className={`${fade()} flex flex-wrap gap-4`} style={{ transitionDelay: "220ms" }}>
              <button
                onClick={() => navigate("/services")}
                className="px-8 py-3 bg-[#1C1A16] text-[#F7F3EC] text-sm font-semibold hover:bg-[#C4622D] transition-colors cursor-pointer border-none"
              >
                Get Started
              </button>
              <a
                href="#testimonials"
                className="px-8 py-3 border border-[#1C1A16] text-[#1C1A16] text-sm font-semibold no-underline hover:bg-[#1C1A16] hover:text-[#F7F3EC] transition-all"
              >
                Testimonials
              </a>
            </div>

            <div className={`${fade()} flex flex-col md:flex-row gap-6  items-start md:items-center mt-16 pt-10 border-t border-[#E0D9CC]`}
              style={{ transitionDelay: "300ms" }}>
              <span className="text-[0.72rem] font-semibold tracking-[0.1em] uppercase text-[#9C9488]">
                Reach us
              </span>
              <div className="flex gap-2">
                {HERO_SOCIALS.map((s) => (
                  <Link
                    key={s.label}
                    to={s.href}
                    className="flex mr-4 items-center  gap-2 text-[#6B6457] text-[1rem] md:text-[1.3rem] no-underline hover:text-[#C4622D] transition-colors"
                  >
                    {s.icon}
                    {s.label}
                  </Link>
                ))}
              </div>
            </div>
          </span>
          <DotLottieReact
            src="https://lottie.host/0d91da13-edff-46eb-a479-4a0ecd71521c/T28MyXo87Z.json"
            loop
            autoplay
            style={{ width: "100%", maxWidth: "300px", height: "auto" }}

          />

        </div>

      </section>

      {/* ── As Seen In ── */}
      <section className="bg-[#EDE7D9] px-8 py-10 border-b border-[#E0D9CC]">
        <div className="max-w-[1100px] mx-auto">
          <p className="text-[0.68rem] font-semibold tracking-[0.14em] uppercase text-[#9C9488] mb-6 text-center">
            Proudly supported by
          </p>
          <div className="flex flex-wrap items-center justify-center opacity-50 gap-x-12 gap-y-5">
            {PARTNERS.map((p, i) => (
              <a key={i} href={p.href} target="_blank" rel="noopener noreferrer">
                <img src={p.src} alt="" className="object-contain h-5 grayscale" />
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ── About ── */}
      <section className="px-8 py-28 border-b border-[#E0D9CC]" id="goalsect">
        <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 items-start">

          <div>
            <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4">
              About Us
            </p>
            <h2 className="sc-serif text-[clamp(2rem,3.5vw,2.75rem)] leading-[1.15] text-[#1C1A16] mb-6">
              Ten years of trusted recovery services
            </h2>
            <p className="text-[#6B6457] leading-[1.8] text-[0.95rem]">
              For over 10 years, ShieldCrypt has established itself as a prominent platform for recovery and investment services.
              Our unwavering commitment to providing individuals with effective solutions to their grievances, including those pertaining to cryptocurrency,
              has been a hallmark of our operation.
            </p>
            <NavLink
              to="/contact"
              className="inline-block mt-8 px-8 py-3 bg-[#1C1A16] text-[#F7F3EC] text-sm font-semibold no-underline hover:bg-[#C4622D] transition-colors"
            >
              Contact us
            </NavLink>

          </div>

          <div className="flex flex-col gap-0">
            {ABOUT_POINTS.map((text, i) => (
              <div key={i} className="flex gap-4 py-5 border-b border-[#E0D9CC]">
                <span className="text-[#C4622D] font-bold text-[0.72rem] min-w-[1.5rem] pt-[2px]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-[#6B6457] text-[0.88rem] leading-[1.7]">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How It Works ── */}
      <section className="bg-[#EDE7D9] px-8 py-28 border-b border-[#E0D9CC]">
        <div className="max-w-[1100px] mx-auto">

          <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
            <div>
              <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-3">
                Process
              </p>
              <h2 className="sc-serif text-[clamp(1.8rem,3vw,2.5rem)] text-[#1C1A16] leading-[1.15]">
                How it Works
              </h2>
            </div>
            <p className="text-[#6B6457] text-[0.9rem] leading-[1.7] max-w-[360px]">
              We invite you to reach out to us with any concerns you may have, as we are confident in our capacity to provide effective solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#D6CDB8]">
            {HOW_IT_WORKS.map((item) => (
              <NavLink
                key={item.step}
                to="/contact"
                className="p-10 border-r border-b border-[#D6CDB8] no-underline bg-[#EDE7D9] hover:bg-[#E5DFCF] transition-colors block"
              >
                <p className="text-[0.65rem] font-bold tracking-[0.14em] text-[#9C9488] mb-6">
                  {item.step}
                </p>
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-[#1C1A16] font-semibold text-[0.95rem] mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-[#6B6457] text-[0.85rem] leading-[1.7]">{item.desc}</p>
              </NavLink>
            ))}
          </div>
        </div>
      </section>

      {/* ── Services ── */}
      <section className="px-8 py-28 border-b border-[#E0D9CC]">
        <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-20 items-start">

          <div className="md:sticky md:top-20">
            <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-3 flex items-center gap-1">
              <FaShieldAlt size={10} /> Our Services
            </p>
            <h2 className="sc-serif text-[clamp(1.8rem,3vw,2.5rem)] text-[#1C1A16] leading-[1.15] mb-5">
              We Offer an extensive range of services
            </h2>
            <p className="text-[#6B6457] text-[0.9rem] leading-[1.75] mb-8">
              We offer tailored solutions to recover all kinds of assets, and we accompany you throughout the whole process.
            </p>
            <Link
              to="/contact"
              className="inline-block px-8 py-3 bg-[#1C1A16] text-[#F7F3EC] text-sm font-semibold no-underline hover:bg-[#C4622D] transition-colors"
            >
              Get a free consultation
            </Link>
          </div>

          <div className="flex flex-col">
            {SERVICES.map((s) => (
              <Link
                key={s.title}
                to="/services"
                className="group flex gap-6 items-start py-7 border-b border-[#E0D9CC] no-underline pl-3 border-l-[3px] border-l-transparent hover:border-l-[#C4622D] hover:bg-[#EDE7D9] hover:pl-5 transition-all"
              >
                <div className="mt-[2px] shrink-0">{s.icon}</div>
                <div className="flex-1">
                  <h3 className="text-[#1C1A16] font-semibold text-[0.95rem] mb-1">{s.title}</h3>
                  <p className="text-[#6B6457] text-[0.85rem] leading-[1.65]">{s.desc}</p>
                </div>
                <span className="text-[#C4622D] text-base mt-[2px] shrink-0">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <FAQ />

      {/* ── Testimonials ── */}
      <section className="bg-[#1C1A16] px-8 py-28" id="testimonials">
        <div className="max-w-[1100px] mx-auto">

          <div className="mb-12">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => <FaStar key={i} size={13} color="#10b981" />)}
            </div>
            <h2 className="sc-serif text-[clamp(2rem,3.5vw,2.75rem)] text-[#F7F3EC] mb-2">
              Rated <em>Excellent</em>
            </h2>
            <p className="text-[#5C5A54] text-[0.9rem]">
              Based on <span className="text-[#F7F3EC]">5,247 reviews</span> on Trustpilot
            </p>
          </div>

          <div className="flex gap-5 pb-4 overflow-x-auto scrollbar-hide">
            {TESTIMONIALS.map((t) => (
              <div
                key={t.name}
                className="shrink-0 w-[290px] bg-[#F7F3EC] p-6 flex flex-col gap-3 rounded-md"
              >
                <div className="flex gap-[2px]">
                  {[...Array(5)].map((_, j) => (
                    <div key={j} className="w-[18px] h-[18px] bg-[#10b981] flex items-center justify-center">
                      <FaStar size={9} color="#fff" />
                    </div>
                  ))}
                </div>

                {t.verified && (
                  <div className="flex items-center gap-1">
                    <FaIdBadge size={11} color="#10b981" />
                    <span className="text-[0.7rem] text-[#9C9488] font-medium">Verified Recovery</span>
                  </div>
                )}

                <h3 className="text-[0.85rem] font-semibold text-[#1C1A16] leading-snug">{t.title}</h3>
                <p className="text-[0.82rem] text-[#6B6457] leading-[1.65] flex-1">{t.content}</p>

                <div className="flex items-center gap-3 pt-3 border-t border-[#E0D9CC]">
                  <div className="w-9 h-9 bg-[#e7f8f2] flex items-center justify-center shrink-0">
                    <span className="text-[0.7rem] font-bold text-[#10b981]">{t.initials}</span>
                  </div>
                  <div>
                    <p className="text-[0.82rem] font-semibold text-[#1C1A16]">{t.name}</p>
                    <p className="text-[0.72rem] text-[#9C9488]">{t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
